import React, { useState, useEffect, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import * as apicall from "../../components/Apicall";
import "../../App.css";
import { IoArrowBack } from "react-icons/io5";
import { toast, useToast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import * as constants from "../../constants/Constants";
import axios from "axios";
import "../../App.css";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { useJsApiLoader } from "@react-google-maps/api";
import { GoogleMap, LoadScript, Autocomplete } from "@react-google-maps/api";
import CouponModel from "./CouponModel";
import Loader from "../../components/Loader";

const addresstype = [
  { id: 0, name: "Home" },
  { id: 1, name: "Office" },
  { id: 2, name: "other" },
  { id: 3, name: "Work" }
];
const preference_people = ["Men", "Women", "No Preference"];
const OrderForm = (props) => {
  const [services, setServices] = useState([]);
  const [start_hour, setStartHours] = useState([]);
  const [end_hour, setEndHours] = useState();
  const [hour_buffer, setHourBuffer] = useState();
  const [day_buffer, setDayBuffer] = useState();
  const [memberShipPlans, setMemberShipPlans] = useState([]);
  const [serviceOfferings, setServiceOfferings] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [loadingServiceTypes, setLoadingServiceTypes] = useState(false);
  const hasServiceTypes = serviceTypes.length > 0;
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [loadingServices, setLoadingServices] = useState(true);
  const [loadingStates, setLoadingStates] = useState(true);
  const [importantData, setImportantData] = useState(true);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedServiceType, setSelectedServiceType] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  const [serviceLocation, setServicelocation] = useState([]);
  const [selectServiceName, setSelectedServiceName] = useState();
  const [servicePmLocation, setServicePMlocation] = useState([]);
  const [pmLocation, setPMLocation] = useState([]);
  const [userDetails, setUserDetails] = useState(null);
  const [userId, setUserId] = useState();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [houseNo, setHouseNo] = useState();
  const [houseName, setHouseName] = useState();
  const [landMark, setLandMark] = useState();
  const [addressText, setAddressText] = useState();
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [state, setState] = useState("");
  const [saveAs, setSaveAs] = useState("");
  const [userExists, setUserExists] = useState(false);
  const [createdUsers, setCreatedUsers] = useState([]); // to track users already created in-session
  const [errors, setErrors] = useState({});
  const [system_offered_price, setSystem_offered_price] = useState();
  const [systemCoupondiscount, setSystem_coupon_discount] = useState(0);
  const [paymentOption, setPaymentOption] = useState(5);
  const [system_displayTax, setSystem_displayTax] = useState(0);
  const [system_total, setSystem_total] = useState(0);
  const [system_taxes, setSystem_taxes] = useState(0);
  const [system_subtotal, setSystem_subtotal] = useState();
  const [system_rawtotal, setSystem_rawTotal] = useState();
  const [system_admin_fee, setSystem_admin_fee] = useState(0);
  const [system_payment, setSystemPayment] = useState(0);
  const [user_coupon_discount, setUser_coupon_discount] = useState(0);
  const [userPrice, setUserPrice] = useState(0);
  const [cash_handling_fee, setCash_handling_fee] = useState();
  const [originalCashFee, setOriginalCashFee] = useState();
  const [firstTimeCaptured, setFirstTimeCaptured] = useState(true);
  const [sliderTouched, setSliderTouched] = useState(false);
  const [collapse, setCollapse] = useState({
    orderSummary: false,
    paymentSummary: true,
    finalpaymentSummary: true
  });
  const [loader, setLoader] = useState(false);
  const [availableCoupons, setAvailableCoupons] = useState([]);
  const [inputCoupon, setInputCoupon] = useState("");
  const [couponLoader, setCouponLoader] = useState(false);
  const [showRemoveCoupon, setShowRemoveCoupon] = useState(false);
  const [isOfferedPriceManual, setIsOfferedPriceManual] = useState(false);

  const [showCoupons, setShowCoupons] = useState(false);
  const [inputUserPrice, setInputUserPrice] = useState(0);
  const [inputUserPriceError, setInputUserPriceError] = useState("");
  const [lowPriceMessage, setLowPriceMessage] = useState("");
  const [quoted_admin_fee, setQuoted_admin_fee] = useState(0);
  const [user_taxes, setUser_taxes] = useState(0);
  const [user_total, setUser_total] = useState(0);
  const [coupon, setCoupon] = useState();
  const [showPaymentSummary, setShowPaymentSummary] = useState(false);
  const [distance, setDistance] = useState("");
  const [stateList, setStatesList] = useState();
  const [booking_id, setBookingId] = useState();
  const [loading, setLoading] = useState();
  const [peopleCount, setPeopleCount] = useState(1);
  const [totalPrice, setTotalPrice] = useState(0);
  const [slots, setSlots] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [inputOfferedPrice, setInputOfferedPrice] =
    useState(system_offered_price);
  const [selectedImages, setSelectedImages] = useState([]);
  const [imagePreview, setImagePreview] = useState();
  const fileInputImageRef = useRef(null);

  const minTime = new Date();
  minTime.setHours(start_hour, 0, 0, 0);
  const maxTime = new Date();
  maxTime.setHours(end_hour, 0, 0, 0);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    if (files.length > 0) {
      setSelectedImages((prev) => [...prev, ...files]);
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(files[0]);
      setErrors((prev) => {
        const { imagePreview, ...rest } = prev;
        return rest;
      });
    }
  };

  const getBase64Img = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (err) => reject(err);
      reader.readAsDataURL(file);
    });
  };

  const getCurrentDate = () => {
    const now = new Date();
    return now.toISOString().split("T")[0];
  };

  const ref = useRef();

  const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`; // "HH:MM"
  };

  const getAvailableCoupons = async (bookingID) => {
    try {
      let res = await apicall.get("getCoupons/" + bookingID);
      setAvailableCoupons(res?.data);
    } catch (e) {
    } finally {
    }
  };

  const validateUserPrice = async (data) => {
    try {
      setInputUserPriceError("");
      setLowPriceMessage("");
      let inputUserPrice = data ? data : inputUserPrice;
      if (inputUserPrice && sliderTouched) {
        var userPrice = parseFloat(inputUserPrice).toFixed(2);

        if (
          parseFloat(system_payment.min_quoted_price) <= userPrice &&
          userPrice <= parseFloat(system_payment.max_quoted_price)
        ) {
          setUserPrice(parseFloat(inputUserPrice).toFixed(2));

          if (userPrice <= system_payment.calculated_price) {
            setLowPriceMessage(
              "Lower price may lower the chance of acceptance by vendor"
            );
          }

          var discount = 0;
          if (coupon) {
            discount = (userPrice / 100) * parseFloat(coupon.value).toFixed(2);
            setUser_coupon_discount(parseFloat(discount).toFixed(2));
          }
          const taxable_amount = userPrice - discount;
          const total_tax_percentage = parseInt(
            system_payment?.vat?.replace("%", "")
          );

          // calculate admin fee
          const admin_price = (
            (userPrice / 100) *
            system_payment.admin_percenatege
          ).toFixed(2);
          const admin_fee = parseFloat(admin_price - discount).toFixed(2);

          setQuoted_admin_fee(admin_fee);
          var total_tax =
            (taxable_amount * total_tax_percentage) / 100 +
            parseFloat(system_payment.platform_fee);
          setUser_taxes(parseFloat(total_tax).toFixed(2));
          let total = parseFloat(taxable_amount + total_tax).toFixed(2);
          // if (parseInt(wallet) >= parseInt(walletUsed)) {
          //   setShowWallet(true);
          // } else {
          //   setShowWallet(false);
          // }

          if (paymentOption == 5) {
            total = parseFloat(total) + parseFloat(cash_handling_fee);
          } else {
            total = parseFloat(total);
          }

          total = parseFloat(
            parseFloat(total) + parseFloat(system_payment?.express_fee)
          ).toFixed(2);

          setUser_total(parseFloat(total).toFixed(2));
        } else {
          if (parseFloat(system_payment.min_quoted_price) <= userPrice) {
            setInputUserPriceError("Price exceeds offer. You Sure?");
          } else {
            if (!firstTimeCaptured) {
              setInputUserPriceError(
                "The price is too low. Please increase your offer."
              );
            }
          }
          //setInputUserPriceError("Entered price is too low")
          setUserPrice(0);
        }
      }
    } catch (e) {
      // console.log("err---", e);
    }
  };
  const handleUpdateCashFee = (value) => {
    setCash_handling_fee(value);
    systemCalculation(
      system_payment,
      value,
      originalCashFee,
      isOfferedPriceManual ? system_offered_price : null
    );
  };

  const handleofferedprice = (e) => {
    const val = e.target.value;
    if (!isNaN(val)) {
      setIsOfferedPriceManual(true);
      setSystem_offered_price(val);
      systemCalculation(system_payment, null, null, val);
    }
  };

  const changeCollapse = (data) => {
    try {
      setCollapse({ ...collapse, [data]: !collapse[data] });
    } catch (e) {
      // console.log("err--", e);
    }
  };
  const resetBtn = () => {
    try {
      setInputUserPrice(parseInt(system_offered_price));
      setUser_coupon_discount(0);
      setUserPrice(0);
      setFirstTimeCaptured(true);
      setSliderTouched(false);
      setLowPriceMessage("");
    } catch (e) {
      console.log("err---", e);
    }
  };
  const sliderChanges = (data) => {
    try {
      setInputUserPrice(data);
      validateUserPrice(data);
      setSliderTouched(true);
    } catch (e) {
      console.log("err---", e);
    }
  };

  useEffect(() => {
    setInputOfferedPrice(system_offered_price);
    systemCalculation(system_payment);
    validateUserPrice(inputUserPrice);
  }, [system_payment, coupon, paymentOption, inputCoupon]);
  const updateClickedCoupon = (data) => {
    setShowCoupons(false);
    setInputCoupon(data?.code);
    setShowRemoveCoupon(true);
    setCoupon(data);
  };
  const initialFormData = {
    userName: "",
    contactNumber: "",
    address: "",
    addressType: "",
    homeNo: "",
    area: "",
    landmark: "",
    state: "",
    address2: "",
    addressType2: "",
    homeNo2: "",
    area2: "",
    landmark2: "",
    state2: "",
    Service: "",
    serviceType: "",
    serviceOffering: "",
    servicedate: getCurrentDate(),
    servicetime: getCurrentTime(),
    splinstruction: "",
    lat2: "",
    lng2: "",
    lat: "",
    lng: "",
    prefofpeople: "",
    numofperson: 1
  };
  const [formData, setFormData] = useState(initialFormData);

  const getDistance = async (pickupAddress, dropAddress) => {
    try {
      const body = {
        pickupAddress_lat: pickupAddress.latitude,
        pickupAddress_lng: pickupAddress.longitude,
        dropAddress_lat: dropAddress.latitude,
        dropAddress_lng: dropAddress.longitude,
        keyUrl: constants.google_distance_key
      };

      const res = await apicall.post(body, "get_distance");
      // console.log(res,"res")
      if (res.result.rows[0]?.elements[0]?.distance?.text) {
        var distance_in_km =
          res.result.rows[0].elements[0].distance.text.replace(" km", "");
        // console.log(distance_in_km,"distance_in_km")
        distance_in_km = distance_in_km.replace(" m", "");
        setDistance(distance_in_km);
      } else {
        setDistance(1);
      }
    } catch (error) {
      console.error("Error fetching distance:", error.message);
    }
  };

  const ddmmyyyy = (dateObj) => {
    const d = new Date(dateObj);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  };
  const fetchServiceOfferings = async (
    service_id,
    service_type_id,
    selectdate,
    state
  ) => {
    setLoadingStates(true);
    try {
      const body = {
        date: ddmmyyyy(new Date(selectdate)),
        state1: state,
        state2: state
      };
      const res = await apicall.post(
        body,
        `service_offerings/${service_id}/${service_type_id}`
      );
      setServiceOfferings(res.data);

      setFormData((prev) => ({
        ...prev,
        serviceOffering: ""
      }));
    } catch (err) {
      console.error("Error fetching offerings:", err);
    } finally {
      setLoadingStates(false);
    }
  };
  const handleServiceSelect = (service) => {
    setStartHours(service.start_hour);
    setEndHours(service.end_hour);
    setDayBuffer(service.day_buffer);
    setHourBuffer(service?.hour_buffer);

    const start = `${String(service.start_hour).padStart(2, "0")}:00`;
    const end = `${String(service.end_hour).padStart(2, "0")}:00`;

    const generatedSlots = generateTimeSlots(start, end);
    setSlots(generatedSlots);
  };

  const fetchServices = async (countryId) => {
    try {
      const res = await apicall.get(`services?country_id=${countryId}`);
      setServices(res?.data);
      setStartHours(res?.data?.map((service) => service.start_hour));
      setEndHours(res?.data?.map((service) => service.end_hour));
    } catch (error) {
      console.error("Failed to fetch services:", error);
    } finally {
      setLoadingServices(false);
    }
  };

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const res = await apicall.get("stateList");
        setStatesList(res?.data);
      } catch (error) {
        console.error("Failed to fetch stateList:", error);
      } finally {
        setLoadingServices(false);
      }
    };
    fetchStates();
    fetchAppdata();
  }, []);

  // UAE = country_id 1, India (+91) = country_id 2
  const contactCountryId = formData.contactNumber?.startsWith("91") ? 2 : 1;

  useEffect(() => {
    setLoadingServices(true);
    fetchServices(contactCountryId);
    setFormData((prev) => ({
      ...prev,
      Service: "",
      serviceType: "",
      serviceOffering: ""
    }));
  }, [contactCountryId]);
  const fetchAppdata = async () => {
    try {
      const res = await apicall.get("appData");
      // console.log(res,"res")
      setImportantData(res?.data);
    } catch (error) {
      console.error("Failed to fetch stateList:", error);
    } finally {
      setLoadingServices(false);
    }
  };
  useEffect(() => {
    const selectedServiceName = services.find(
      (s) => s.id === formData.Service
    )?.name;
    if (selectedServiceName === "Packers & Movers" || loadingServiceTypes)
      return;

    if (
      formData.Service &&
      formData.servicedate &&
      formData.state &&
      (hasServiceTypes ? formData.serviceType : true)
    ) {
      fetchServiceOfferings(
        formData.Service,
        hasServiceTypes ? formData.serviceType : 0,
        formData.servicedate,
        formData.state
      );
    }
  }, [
    formData.Service,
    formData.serviceType,
    formData.servicedate,
    formData.state,
    services,
    hasServiceTypes,
    loadingServiceTypes
  ]);

  const fetchPackersServiceOfferings = async (
    service_id,
    selectdate,
    pickupState,
    dropState,
    rawDistance
  ) => {
    setLoadingStates(true);
    try {
      let distance = 0;
      if (typeof rawDistance === "string" && rawDistance.includes("m")) {
        distance = Number(rawDistance.replace("m", "").trim()) * 0.001;
      } else {
        distance = parseFloat(rawDistance);
      }

      const body = {
        distance: rawDistance,
        date: ddmmyyyy(new Date(selectdate)),
        state1: pickupState,
        state2: dropState
      };

      const res = await apicall.post(body, `service_offerings/${service_id}`);
      setServiceOfferings(res.data);
      // console.log(res)
    } catch (err) {
      alert("Something went wrong");
    } finally {
      setLoadingStates(false);
    }
  };

  useEffect(() => {
    if (
      formData.Service &&
      formData.servicedate &&
      formData.state &&
      formData.state2 &&
      distance
    ) {
      fetchPackersServiceOfferings(
        formData.Service,
        formData.servicedate,
        formData.state,
        formData.state2,
        distance
      );
    }
  }, [
    formData.Service,
    formData.servicedate,
    formData.state,
    formData.state2,
    distance
  ]);
  const fetchServiceTypes = async (serviceId) => {
    setServiceTypes([]);
    setLoadingServiceTypes(true);
    try {
      const res2 = await apicall.get(`services_types/${serviceId}`);

      setServiceTypes(res2.data || []);
    } catch (error) {
      console.error("Failed to fetch states:", error);
    } finally {
      setLoadingStates(false);
      setLoadingServiceTypes(false);
    }
  };
  const selectedoffService = serviceOfferings.find(
    (s) => s.id === formData.serviceOffering
  );
  const servicesWithMax4 = ["Cleaning Service", "Hourly Deep Cleaning"];
  const maxPeople = servicesWithMax4.includes(selectedoffService?.name)
    ? 4
    : importantData?.maxPeople || 4;

  useEffect(() => {
    if (formData.serviceOffering) {
      calculatePrice(peopleCount, formData.serviceOffering);
    } else {
      setTotalPrice(0);
    }
  }, [peopleCount, formData.serviceOffering, selectedoffService]);
  const calculatePrice = (count, selectedServiceId) => {
    try {
      const selected_offService = serviceOfferings.find(
        (s) => s.id === selectedServiceId
      );

      if (!selected_offService) {
        setTotalPrice(0);
        return;
      }

      const amount = parseFloat(
        selected_offService.cost_with_admin_fee.replace(/[^0-9.]/g, "")
      );
      setTotalPrice(amount);
      if (count === 1) {
        setTotalPrice(amount.toFixed(2));
      } else {
        let extraAmount =
          (selected_offService.peopleCountPercent / 100) * amount;
        extraAmount = extraAmount * (count - 1);
        setTotalPrice((amount + extraAmount).toFixed(2));
      }
    } catch (e) {
      console.log("err---", e);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

    const newErrors = { ...errors };
    switch (name) {
      case "homeNo":
        if (!value) {
          newErrors.homeNo = "House number is required";
        } else {
          delete newErrors.homeNo;
        }
        break;
      case "area":
        if (!value) {
          newErrors.area = "Area is required";
        } else {
          delete newErrors.area;
        }
        break;
      case "landmark":
        if (!value) {
          newErrors.landmark = "Landmark is required";
        } else {
          delete newErrors.landmark;
        }
        break;
      case "state":
        if (!value) {
          newErrors.state = "State is required";
        } else {
          delete newErrors.state;
        }
        break;
      case "serviceOffering":
        if (!value) {
          newErrors.serviceOffering = "Service Offering is required";
        } else {
          delete newErrors.serviceOffering;
        }
        if (!value) {
          newErrors.prefofpeople = "Preference of people is required";
        } else {
          delete newErrors.prefofpeople;
        }
        if (!value) {
          newErrors.imagePreview = "Please upload Image";
        } else {
          delete newErrors.imagePreview;
        }

        break;
      default:
        break;
    }

    setErrors(newErrors);
  };
  const validateDateAndTime = () => {
    if (!formData.servicedate || !formData.servicetime) return true;

    const [year, month, day] = formData.servicedate.split("-").map(Number);
    let [hour, minute] = formData.servicetime.split(":").map(Number);
    hour = hour || 0;
    minute = minute || 0;

    const targetDate = new Date(year, month - 1, day, hour, minute, 0);

    // Minimum allowed date = today + 1 day
    const minDate = new Date();
    minDate.setDate(minDate.getDate() + 1);
    minDate.setHours(0, 0, 0, 0); // from start of tomorrow

    if (targetDate < minDate) {
      window.alert(
        "Selected time slot is unavailable. Please choose a date from tomorrow onwards."
      );
      return false;
    }

    return true;
  };

  const handlePhoneChange = (value) => {
    setFormData((prev) => ({ ...prev, contactNumber: value }));
  };
  const selectedService = services.find(
    (service) => service.id === formData.Service
  );
  const isPackerMoversSelected = selectedService?.name === "Packers & Movers";
  const selectedServicesList = [
    "Packers & Movers",
    "Handyman",
    "Appliances Repair"
  ];
  const isSelectedServices = selectedServicesList.includes(
    selectedService?.name
  );

  useEffect(() => {}, [
    selectedServices,
    selectedServiceType,
    serviceLocation,
    servicePmLocation,
    formData.serviceType,
    services
  ]);
  const navigateBack = () => {
    navigate("/bookings");
  };
  const get_user = async () => {
    try {
      const body = {
        contact: formData.contactNumber
      };
      // console.log(body, "contact");

      const res = await apicall.post(body, "get_usersinfo");
      console.log(res.data);
      if (res.data.length > 0) {
        setUserExists(false);
        setUserDetails(res.data);
        // setUserId(res.data[0]?.id);
      } else {
        setUserExists(true);
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    }
  };
  const handleSearch = async () => {
    try {
      const body = {
        contact: formData.contactNumber
      };
      // console.log(body, "contact");

      const res = await apicall.post(body, "get_user");
      // console.log(res.data);

      if (res.data.length === 0) {
        toast.error("No user found, please create user");
        setUserExists(true); // user not found
        // setUserId(null);
        setFormData({ ...formData, userName: "" });
      } else {
        setUserExists(false); // user found
        setUserId(res.data[0]?.id);
        setFormData({ ...formData, userName: res.data[0]?.first_name || "" });
        get_user();
      }
    } catch (err) {
      console.error(err);
      setUserExists(false);
    }
  };

  const SaveAddress = async () => {
    if (
      !addressText ||
      !houseName ||
      !landMark ||
      !houseNo ||
      !state ||
      !saveAs
    ) {
      toast.error("Please enter all Details");
      return;
    }
    try {
      const body = {
        addressText: addressText,
        houseName: houseName,
        houseNo: houseNo,
        landMark: landMark,
        latitude: "",
        longitude: "",
        state: state,
        saveAs: saveAs,
        user_id: userId
      };
      // console.log(body, "contact")
      const res = await apicall.post(body, "saveuserAddress");
      // console.log(res.data);
      setShowModal(false);
      get_user();
      if (res.success) {
        toast.success("Data Updated Successfully");

        const savedData = res.data[0]; // Assuming res.data is an array with at least one object

        // Update Formik fields
        setFormData({ ...formData, address: savedData.address || "" }); // or addressText
        setFormData({ ...formData, addressType: savedData.addressType || "" }); // add this key in backend if not present
        setFormData({ ...formData, houseNo: savedData.houseNo || "" });
        setFormData({ ...formData, houseName: savedData.houseName || "" });
        setFormData({ ...formData, landMark: savedData.landMark || "" });
      }
    } catch (err) {
      console.error(err);
    }
  };
  const isValidPhoneNumber = (number) => {
    const aeRegex = /^971[2-9]\d{8}$/;
    const inRegex = /^91[6-9]\d{9}$/;
    return aeRegex.test(number) || inRegex.test(number);
  };

  const handleCreateUser = async () => {
    const { userName, contactNumber } = formData;

    if (!userName || !contactNumber) {
      toast.error("Please enter both user name and phone number.");
      return;
    }
    if (!isValidPhoneNumber(contactNumber)) {
      toast.error("Invalid phone number format.");
      return;
    }
    const alreadyCreated = createdUsers.some(
      (u) => u.userName === userName && u.contactNumber === contactNumber
    );

    if (alreadyCreated) {
      toast.error("User already exists");
      return;
    }

    try {
      const body = {
        first_name: userName,
        email: "",
        phone_number: contactNumber,
        country: 1,
        state: 1,
        city: 1,
        address: "",
        role: "",
        start_date: "",
        end_date: ""
      };

      const userRes = await apicall.post(body, "createUser");
      if (userRes.success) {
        toast.success("User created successfully");
        setUserId(userRes.data[0].id);
        setUserExists(false); // Hide "Create User" button
        setCreatedUsers((prev) => [...prev, { userName, contactNumber }]); // Track created user
      } else if (userRes.message?.toLowerCase().includes("already exists")) {
        toast.error("User already exists");
      } else {
        toast.error(userRes.message || "Something went wrong");
      }
    } catch (err) {
      console.error(err);
      const errMsg = err.response?.data?.message || "Something went wrong";

      if (errMsg.toLowerCase().includes("already exists")) {
        toast.error("User already exists");
      } else {
        toast.error(errMsg);
      }
    }
  };
  const pay = async () => {
    var admin_fee =
      userPrice == 0
        ? parseFloat(system_admin_fee).toFixed(2)
        : parseFloat(quoted_admin_fee).toFixed(2);

    let paymentCapture;
    if (paymentOption === 5) {
      paymentCapture = "After Service";
    } else {
      paymentCapture = paymentOption === 1 ? "NOW" : "LATER";
    }

    const discount =
      user_coupon_discount == 0 ? systemCoupondiscount : user_coupon_discount;

    var data = {
      quoted_price: userPrice,
      total: "",
      total_discount: system_rawtotal,
      tax: userPrice == 0 ? system_taxes : user_taxes,
      platform_fee: parseFloat(system_payment.platform_fee),
      admin_margin: admin_fee,
      booking_id: booking_id,
      coupon: coupon ? coupon : null,
      coupon_discount: discount,
      payment_capture: paymentCapture,
      wallet: "",
      cash_handling_fee: paymentOption === 5 ? cash_handling_fee : 0
    };

    try {
      setLoader(true);

      var initPayment = await apicall.post(data, "init_payment");
      if (initPayment.success) {
        navigate("/bookings");
      }
    } catch (e) {
      alert(e.message?.replace("Error:", ""));
    } finally {
      setLoader(false);
      setCouponLoader(false);
    }
  };

  const getPaymentDetails = async (booking_id) => {
    try {
      setLoader(true);
      var res = await apicall.get(`/getPaymentAdmin/${booking_id}`);
      setSystemPayment(res.data[0]);
      setCash_handling_fee(
        parseFloat(res.data[0].cash_handling_fee).toFixed(2)
      );
      setOriginalCashFee(parseFloat(res.data[0].cash_handling_fee).toFixed(2));

      getAvailableCoupons(booking_id);
      systemCalculation(res.data[0]);
      setShowPaymentSummary(true);
    } catch (e) {
      alert(e.message?.replace("Error:", ""));
    } finally {
      setLoader(false);
    }
  };

  const systemCalculation = async (data, updatedCashFee, originalFee, val) => {
    try {
      let system_payment = data ? data : system_payment;

      const average_price = parseFloat(system_payment.average_price).toFixed(2);
      const admin_fee = parseFloat(
        (average_price / 100) * system_payment.admin_percenatege
      ).toFixed(2);

      setSystem_admin_fee(parseFloat(admin_fee).toFixed(2));

      let offered_price;
      if (val === null || val === undefined || val === "") {
        offered_price = parseFloat(average_price) + parseFloat(admin_fee);
        if (!isOfferedPriceManual) {
          setSystem_offered_price(parseFloat(offered_price).toFixed(2));
        }
      } else {
        offered_price = parseFloat(val);
      }

      let discount = 0;
      if (coupon) {
        discount = (offered_price / 100) * parseFloat(coupon.value).toFixed(2);
        setSystem_coupon_discount(parseFloat(discount).toFixed(2));
      } else {
        setSystem_coupon_discount(0);
      }

      let subtotal_after_discount =
        parseFloat(offered_price) - parseFloat(discount);
      setSystem_subtotal(parseFloat(subtotal_after_discount).toFixed(2));

      const total_tax_percentage = parseInt(
        system_payment.vat?.replace("%", "")
      );

      let tax_before_discount = (
        (parseFloat(offered_price) * total_tax_percentage) /
        100
      ).toFixed(2);

      let tax_after_discount = (
        (parseFloat(subtotal_after_discount) * total_tax_percentage) /
        100
      ).toFixed(2);

      setSystem_taxes(parseFloat(tax_after_discount).toFixed(2));

      const display_total =
        parseFloat(tax_after_discount) +
        parseFloat(system_payment.platform_fee);
      setSystem_displayTax(parseFloat(display_total).toFixed(2));

      let total =
        parseFloat(subtotal_after_discount) +
        parseFloat(tax_after_discount) +
        parseFloat(system_payment.platform_fee) +
        parseFloat(system_payment?.express_fee || 0);

      if (paymentOption == 5) {
        total += parseFloat(
          updatedCashFee ? updatedCashFee : cash_handling_fee
        );
      }

      total = parseFloat(total) + parseFloat(system_payment?.express_fee || 0);
      setSystem_rawTotal(parseFloat(total).toFixed(2));

      let rawTotal =
        parseFloat(offered_price) +
        parseFloat(tax_before_discount) +
        parseFloat(system_payment.platform_fee) +
        parseFloat(system_payment?.express_fee || 0);

      if (paymentOption == 5) {
        rawTotal += parseFloat(
          updatedCashFee ? updatedCashFee : cash_handling_fee
        );
      }

      system_total(parseFloat(rawTotal).toFixed(2));
    } catch (e) {
      // console.log("err--", e, e.message);
    }
  };

  const removeCoupon = () => {
    // e.preventDefault();
    setInputCoupon("");
    setShowRemoveCoupon(false);
    setCoupon(null);
  };
  const validateCoupon = async () => {
    try {
      if (inputCoupon != "") {
        setCouponLoader(true);
        setShowRemoveCoupon(true);
        var data = {
          service_id: system_payment.service_id,
          coupon_code: inputCoupon
        };
        var res = await apicall.post(data, "validate_coupon");
        // console.log(res.data,"res.data")
        if (res.data.length > 0) {
          setCoupon(res.data[0]);
        } else {
          setShowRemoveCoupon(false);
          setInputCoupon("");
          toast.error(
            "Invalid Coupon!",
            "Coupon code is not correct or Coupon is expired!"
          );
        }
      }
    } catch (e) {
      alert(e.message?.replace("Error:", ""));
    } finally {
      setCouponLoader(false);
    }
  };
  useEffect(() => {
    setCash_handling_fee(
      parseFloat(system_payment?.cash_handling_fee).toFixed(2)
    );
  }, [errors]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formData.Service) newErrors.Service = "Service is required";
    if (!formData.serviceOffering)
      newErrors.serviceOffering = "Service Offering is required";
    if (!formData.address) newErrors.address = "Address is required";
    if (!formData.homeNo) newErrors.homeNo = "House number is required";
    if (!formData.area) newErrors.area = "Area is required";
    if (!formData.servicedate)
      newErrors.servicedate = "Service date is required";
    if (!formData.servicetime)
      newErrors.servicetime = "Service time is required";
    if (!formData.state) newErrors.state = "State is required";
    // if (!formData.numofperson) newErrors.numofperson = "Number of Persons is required";

    // if (!formData.prefofpeople) newErrors.prefofpeople = "Preference is required";

    const selectedService = services.find(
      (service) => service.id === formData.Service
    );
    const serviceName = selectedService?.name || "";

    if (serviceName === "Packers & Movers") {
      if (!formData.address2) newErrors.address2 = "Drop address is required";
      if (!formData.homeNo2)
        newErrors.homeNo2 = "Drop house number is required";
      if (!formData.area2) newErrors.area2 = "Drop area is required";
      if (!formData.state2) newErrors.state2 = "Drop state is required";
    }
    if (hasServiceTypes && !formData.serviceType) {
      newErrors.serviceType = "Service type is required";
    }
    if (
      selectedServicesList.includes(serviceName) &&
      selectedImages.length === 0
    ) {
      newErrors.imagePreview = "Please upload  image";
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setLoading(true);

    let data = {};
    let apiUrl = "";
    const paymentCapture = serviceName === "Landscaping" ? 6 : 5;

    if (["Packers & Movers", "Item Moving"].includes(serviceName)) {
      let d1 = Number(distance.replace("m", "").trim()) * 0.001;

      data = {
        p_location: formData.address,
        p_lat: formData.lng,
        p_lng: formData.lat,
        p_house_no: formData.homeNo,
        p_area: formData.area,
        p_landmark: formData.landmark,
        d_location: formData.address2,
        d_lat: formData.lat2,
        d_lng: formData.lng2,
        d_house_no: formData.homeNo2,
        d_area: formData.area2,
        d_landmark: formData.landmark,
        item_details: "",
        service_id: formData.Service,
        service_offering: formData.serviceOffering,
        service_date: formData.servicedate,
        service_time: formData.servicetime,
        distance: d1,
        from_state: formData.state,
        to_state: formData.state2,
        user_id: userId,
        main: "1",
        cart_payment: "1"
      };
      apiUrl = "book_packersAndMovers_admin";
    } else {
      data = {
        s_location: formData.address,
        s_lat: formData.lat,
        s_lng: formData.lng,
        s_house_no: formData.homeNo,
        s_area: formData.area,
        s_landmark: formData.landmark,
        service_date: formData.servicedate,
        service_time: formData.servicetime,
        service_state: formData.state,
        service_id: formData.Service,
        service_offering: formData.serviceOffering,
        item_details: "",
        service_type: formData.serviceType || 0,
        user_id: userId,
        main: "1",
        cart_payment: "1",
        prefofpeople: formData.prefofpeople || "No Preference",
        numofperson: peopleCount,
        payment: paymentCapture
      };
      apiUrl = "book_admin_services";
    }
    try {
      const response = await apicall.post(data, `/${apiUrl}`);
      const booking_id = response?.data?.booking_id;
      const bookingencrId = response.data.bookingencrId;
      setBookingId(bookingencrId);

      if (booking_id) {
        if (selectedImages.length > 0) {
          for (const img of selectedImages) {
            const base64Image = await getBase64Img(img);
            if (base64Image) {
              const imageData = { booking_id, image: base64Image };

              if (serviceName === "Packers & Movers") {
                // 👇 use correct endpoint for packers & movers
                await apicall.post(imageData, "/uploadSupportImages");
              } else {
                // 👇 for other services (if images are supported)
                await apicall.post(imageData, "/uploadSupportOtherImages");
              }
            }
          }
        }

        getPaymentDetails(bookingencrId);
        toast.success("Booking successful!");
        setIsButtonDisabled(true);
      } else {
        toast.error("Booking ID not found in response");
      }
    } catch (error) {
      // console.error("Booking failed:", error);
      setIsButtonDisabled(false);
    } finally {
      setLoading(false);
    }
  };
  const handleCancel = () => {
    setFormData(initialFormData);
    setErrors({});
  };

  useEffect(() => {
    const { lat, lng, lat2, lng2 } = formData;

    if (lat && lng && lat2 && lng2) {
      const pickupAddress = {
        latitude: lat,
        longitude: lng,
        state: formData.state
      };
      const dropAddress = {
        latitude: lat2,
        longitude: lng2,
        state: formData.state2
      };
      getDistance(pickupAddress, dropAddress);
    }
  }, [formData.lat, formData.lng, formData.lat2, formData.lng2]);

  const generateTimeSlots = (startTime, endTime, intervalInMinutes = 30) => {
    const slots = [];
    const start = new Date(`1970-01-01T${startTime}:00`);
    const end = new Date(`1970-01-01T${endTime}:00`);

    end.setHours(end.getHours() + 2); // if you want to extend the range by 2 hours

    while (start <= end) {
      const hours = String(start.getHours()).padStart(2, "0"); // 0-padded hour
      const minutes = String(start.getMinutes()).padStart(2, "0"); // 0-padded minute
      const timeStr = `${hours}:${minutes}`; // 24-hour format
      slots.push(timeStr);
      start.setMinutes(start.getMinutes() + intervalInMinutes);
    }

    return slots;
  };

  return (
    <div className="container my-4 p-3 bg-white rounded-3">
      <div className="mb-2 d-flex align-items-center pointer">
        <IoArrowBack size={24} onClick={navigateBack} className="me-2" />
        <h1 className="sub-heading mb-0">Order Details</h1>
      </div>
      <form>
        <div className="row">
          <div className="col-md-12 mt-2">
            <div className="m-2 p-2">
              <p className="sub-heading">User Details</p>
              <div className="row mb-3 align-items-end">
                <div className="col-md-4">
                  <label htmlFor="userName" className="form-label">
                    UserName
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="userName"
                    name="userName"
                    value={formData.userName}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-4">
                  <label htmlFor="contactNumber" className="form-label">
                    Contact
                  </label>
                  <div className="d-flex">
                    <div style={{ flexGrow: 1 }}>
                      <PhoneInput
                        onlyCountries={["ae", "in"]}
                        country={"ae"}
                        value={formData.contactNumber}
                        onChange={handlePhoneChange}
                        inputStyle={{ width: "100%" }}
                      />
                    </div>
                    <button
                      type="button"
                      className="btn btn-sm ms-2"
                      style={{
                        backgroundColor: "#d01c4c",
                        color: "#fff",
                        height: "32px"
                      }}
                      onClick={handleSearch}
                    >
                      Search
                    </button>
                  </div>
                </div>
                {userExists ? (
                  <div className="col-md-4 d-flex align-items-end">
                    <button
                      type="button"
                      className="btn btn-sm"
                      style={{
                        background: "#d01c4c",
                        color: "white",
                        fontSize: "0.8rem",
                        marginBottom: "5px"
                      }}
                      onClick={handleCreateUser}
                    >
                      Create User
                    </button>
                  </div>
                ) : (
                  <div className="col-md-4"></div>
                )}
              </div>
              <div className="row mb-3">
                <div className="col-md-4 mt-2">
                  <label htmlFor="address" className="form-label">
                    Address
                  </label>
                  <select
                    id="address"
                    name="address"
                    value={formData.address}
                    className="form-control"
                    disabled={!userDetails}
                    onChange={(e) => {
                      const selectedLocation = e.target.value;
                      const selectedAddress = userDetails.find(
                        (item) => item.location === selectedLocation
                      );

                      if (selectedAddress) {
                        setFormData((prev) => ({
                          ...prev,
                          address: selectedLocation,
                          homeNo: selectedAddress.house_no,
                          area: selectedAddress.area,
                          landmark: selectedAddress.landmark,
                          addressType: selectedAddress.label,
                          state: selectedAddress.state,
                          lat: selectedAddress.lat,
                          lng: selectedAddress.lng
                        }));
                      } else {
                        setFormData((prev) => ({
                          ...prev,
                          address: selectedLocation
                        }));
                      }

                      // ✅ Clear address error
                      if (errors.address) {
                        setErrors((prev) => ({
                          ...prev,
                          address: ""
                        }));
                      }
                    }}
                  >
                    <option value="">Select address</option>
                    {userDetails?.map((item, index) => (
                      <option key={index} value={item.location}>
                        {item.location}
                      </option>
                    ))}
                  </select>
                  {errors.address && (
                    <div className="text-danger">{errors.address}</div>
                  )}
                </div>

                <div className="col-md-4 mt-2">
                  <label htmlFor="addressType" className="form-label">
                    Address Type
                  </label>
                  <input
                    id="addressType"
                    name="addressType"
                    className="form-control"
                    disabled={true}
                    onChange={handleChange}
                    value={formData.addressType}
                  />

                  {errors.addressType && (
                    <div className="text-danger">{errors.addressType}</div>
                  )}
                </div>

                <div className="col-md-4 mt-2">
                  <label htmlFor="homeNo" className="form-label">
                    Home No
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    disabled={true}
                    id="homeNo"
                    name="homeNo"
                    value={formData.homeNo || ""}
                    onChange={handleChange}
                  />

                  {errors.homeNo && (
                    <div className="text-danger">{errors.homeNo}</div>
                  )}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-4 mt-2">
                  <label htmlFor="area" className="form-label">
                    Area
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    disabled={true}
                    id="area"
                    name="area"
                    value={formData.area || ""}
                    onChange={handleChange}
                  />
                  {errors.area && (
                    <div className="text-danger">{errors.area}</div>
                  )}
                </div>
                <div className="col-md-4 mt-2">
                  <label htmlFor="landmark" className="form-label">
                    Landmark
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    disabled={true}
                    id="landmark"
                    name="landmark"
                    value={formData.landmark || ""}
                    onChange={handleChange}
                  />
                  {errors.landmark && (
                    <div className="text-danger">{errors.landmark}</div>
                  )}
                </div>
                <div className="col-md-4 mt-2">
                  <label htmlFor="state" className="form-label">
                    State
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    disabled={true}
                    id="state"
                    name="state"
                    value={formData.state || ""}
                    onChange={handleChange}
                  />
                  {errors.state && (
                    <div className="text-danger">{errors.state}</div>
                  )}
                </div>
              </div>
              {isPackerMoversSelected && (
                <>
                  <p className="sub-heading mt-4">Drop Address</p>

                  <div className="row mb-3">
                    <div className="col-md-4">
                      <label htmlFor="address2" className="form-label">
                        Address
                      </label>
                      <select
                        id="address2"
                        name="address2"
                        className="form-control"
                        value={formData.address2}
                        onChange={(e) => {
                          const selectedLocation = e.target.value;
                          const selectedAddress = userDetails.find(
                            (item) => item.location === selectedLocation
                          );

                          if (selectedAddress) {
                            setFormData((prev) => ({
                              ...prev,
                              address2: selectedLocation,
                              homeNo2: selectedAddress.house_no,
                              area2: selectedAddress.area,
                              landmark2: selectedAddress.landmark,
                              addressType2: selectedAddress.label,
                              state2: selectedAddress.state,
                              lat2: selectedAddress.lat,
                              lng2: selectedAddress.lng
                            }));
                          } else {
                            setFormData((prev) => ({
                              ...prev,
                              address: selectedLocation
                            }));
                          }
                        }}
                      >
                        <option value="">Select address</option>
                        {userDetails?.map((item, index) => (
                          <option key={index} value={item.location}>
                            {item.location}
                          </option>
                        ))}
                      </select>
                      {errors.address2 && (
                        <div className="text-danger">{errors.address2}</div>
                      )}
                    </div>

                    <div className="col-md-4 mt-2">
                      <label htmlFor="addressType2" className="form-label">
                        Address Type
                      </label>
                      <input
                        id="addressType2"
                        className="form-control"
                        disabled={true}
                        name="addressType2"
                        value={formData.addressType2 || ""}
                        onChange={handleChange}
                      />
                      {errors.addressType2 && (
                        <div className="text-danger">{errors.addressType2}</div>
                      )}
                    </div>

                    <div className="col-md-4 mt-2">
                      <label htmlFor="homeNo2" className="form-label">
                        Home No
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        disabled={true}
                        id="homeNo2"
                        name="homeNo2"
                        value={formData.homeNo2 || ""}
                        onChange={handleChange}
                      />
                      {errors.homeNo2 && (
                        <div className="text-danger">{errors.homeNo2}</div>
                      )}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-4 mt-2">
                      <label htmlFor="area2" className="form-label">
                        Area
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        disabled={true}
                        id="area2"
                        name="area2"
                        value={formData.area2 || ""}
                        onChange={handleChange}
                      />
                      {errors.area2 && (
                        <div className="text-danger">{errors.area2}</div>
                      )}
                    </div>

                    <div className="col-md-4 mt-2">
                      <label htmlFor="landmark2" className="form-label">
                        Landmark
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        disabled={true}
                        id="landmark2"
                        name="landmark2"
                        value={formData.landmark2 || ""}
                        onChange={handleChange}
                      />
                      {errors.landmark2 && (
                        <div className="text-danger">{errors.landmark2}</div>
                      )}
                    </div>

                    <div className="col-md-4 mt-2">
                      <label htmlFor="state2" className="form-label">
                        State
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        disabled={true}
                        id="state2"
                        name="state2"
                        value={formData.state2 || ""}
                        onChange={handleChange}
                      />
                      {errors.state2 && (
                        <div className="text-danger">{errors.state2}</div>
                      )}
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-12 mt-4 d-flex align-items-end justify-content-end">
                <button
                  type="button"
                  className="btn btn"
                  style={{ background: "#d01c4c", color: "white" }}
                  onClick={() => setShowModal(true)}
                >
                  + Add Another address
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-12 mt-2">
            <div className="m-2 p-2">
              <div className="m-2 p-2 d-flex justify-content-between align-items-center">
                <p className="sub-heading mb-0">Service Details</p>
              </div>
              <div className="row mb-3">
                <div className="row mb-3">
                  <div className="col">
                    <label htmlFor="Service" className="form-label">
                      Service
                    </label>
                    <select
                      id="Service"
                      name="Service"
                      className="form-control"
                      value={formData.Service}
                      onChange={(e) => {
                        const selectedServiceId = e.target.value;

                        setFormData((prev) => ({
                          ...prev,
                          Service: selectedServiceId,
                          serviceType: "",
                          serviceOffering: ""
                        }));
                        setServiceOfferings([]);

                        // ✅ Clear Service field error
                        if (errors.Service) {
                          setErrors((prev) => ({
                            ...prev,
                            Service: ""
                          }));
                        }

                        const selectedService = services.find(
                          (service) => service.id === selectedServiceId
                        );
                        if (!selectedService) return;

                        fetchServiceTypes(selectedServiceId);
                        handleServiceSelect(selectedService);
                      }}
                    >
                      <option value="">Select Service</option>
                      {services.map((service) => (
                        <option key={service.id} value={service.id}>
                          {service.name}
                        </option>
                      ))}
                    </select>

                    {errors.Service && (
                      <div className="text-danger">{errors.Service}</div>
                    )}
                  </div>
                  <div className="col">
                    <label htmlFor="servicedate" className="form-label">
                      Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="servicedate"
                      name="servicedate"
                      min={getCurrentDate()}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      value={formData.servicedate}
                    />
                    {errors.servicedate && (
                      <div className="text-danger">{errors.servicedate}</div>
                    )}
                  </div>

                  <div className="col">
                    <label htmlFor="servicetime" className="form-label">
                      Time
                    </label>
                    <select
                      id="servicetime"
                      name="servicetime"
                      className="form-control"
                      value={formData.servicetime}
                      onChange={handleChange}
                    >
                      <option value="">Select Time</option>
                      {slots.map((slot, index) => (
                        <option key={index} value={slot}>
                          {slot}
                        </option>
                      ))}
                    </select>

                    {errors.servicetime && (
                      <div className="text-danger">{errors.servicetime}</div>
                    )}
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="row mb-3"></div>
                  {hasServiceTypes ? (
                    <div className="col">
                      <label htmlFor="serviceType" className="form-label">
                        Service Type
                      </label>
                      {loadingServices ? (
                        <select className="form-select" disabled>
                          <option>Loading services...</option>
                        </select>
                      ) : (
                        <select
                          id="serviceType"
                          name="serviceType"
                          className="form-control"
                          onChange={handleChange}
                          value={formData.serviceType}
                        >
                          <option value="">Select Service Type</option>
                          {serviceTypes.map((service) => (
                            <option key={service.id} value={service.id}>
                              {service.name}
                            </option>
                          ))}
                        </select>
                      )}
                      {errors.serviceType && (
                        <div className="text-danger">{errors.serviceType}</div>
                      )}
                    </div>
                  ) : (
                    <div className="col-md-4"></div>
                  )}

                  <div className="col">
                    <label htmlFor="serviceOffering" className="form-label">
                      Service Offering
                    </label>
                    {loadingServices ? (
                      <select className="form-select" disabled>
                        <option>Loading services...</option>
                      </select>
                    ) : (
                      <select
                        id="serviceOffering"
                        name="serviceOffering"
                        className="form-control"
                        onChange={(e) => {
                          handleChange(e);
                          setErrors((prev) => ({
                            ...prev,
                            serviceOffering: ""
                          }));
                        }}
                        value={formData.serviceOffering}
                      >
                        <option value="">Select Offering</option>
                        {serviceOfferings.map((service) => (
                          <option key={service.id} value={service.id}>
                            {service.name}
                          </option>
                        ))}
                      </select>
                    )}
                    {errors.serviceOffering && (
                      <div className="text-danger">
                        {errors.serviceOffering}
                      </div>
                    )}
                  </div>
                  <div className="col">
                    <label htmlFor="splinstruction" className="form-label">
                      Special Instruction
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="splinstruction"
                      name="splinstruction"
                      onChange={handleChange}
                      value={formData.splinstruction}
                    />
                    {errors.splinstruction && (
                      <div className="text-danger">{errors.splinstruction}</div>
                    )}
                  </div>
                </div>

                <div className="row mb-3">
                  {/* <div className="col-md-4 mt-3">
  <label htmlFor="prefofpeople" className="form-label">Preference For People</label>

  <select
    className="form-select"
    id="prefofpeople"
    name="prefofpeople"
    onChange={handleChange}
    value={formData.prefofpeople || "No Preference"}
  >
    <option value="">Select feedback</option>
    {preference_people.map((f, idx) => (
      <option key={idx} value={f}>
        {f}
      </option>
    ))}
  </select>

  {errors.prefofpeople && <div className="text-danger">{errors.prefofpeople}</div>}
</div> */}
                  {(selectedService?.name === "Cleaning Service" ||
                    selectedService?.name === "Hourly Deep Cleaning") && (
                    <>
                      <div className="col-md-4 mt-3">
                        <label htmlFor="prefofpeople" className="form-label">
                          Preference For People
                        </label>

                        <select
                          className="form-select"
                          id="prefofpeople"
                          name="prefofpeople"
                          onChange={handleChange}
                          value={formData.prefofpeople || "No Preference"}
                        >
                          <option value="">Select Preference</option>
                          {preference_people.map((f, idx) => (
                            <option key={idx} value={f}>
                              {f}
                            </option>
                          ))}
                        </select>

                        {errors.prefofpeople && (
                          <div className="text-danger">
                            {errors.prefofpeople}
                          </div>
                        )}
                      </div>
                      <div className="col-md-4 mt-3">
                        <label htmlFor="numofperson" className="form-label">
                          Number of Persons
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="numofperson"
                          name="numofperson"
                          min={1}
                          max={maxPeople}
                          value={peopleCount}
                          onChange={(e) => {
                            const val = Number(e.target.value);
                            if (val >= 1) {
                              setPeopleCount(val);
                              calculatePrice(val, formData.serviceOffering);
                            } else {
                              setPeopleCount(1);
                              calculatePrice(1, formData.serviceOffering);
                            }
                          }}
                        />

                        <div className="mt-2">
                          <strong>Total Price:</strong> AED {totalPrice || 0}
                        </div>
                      </div>
                    </>
                  )}

                  {isSelectedServices && (
                    <div className="col-md-4 mt-3">
                      <div className="d-flex flex-column">
                        <label className="form-label">Add Photos</label>

                        {!imagePreview && (
                          <>
                            <button
                              type="button"
                              className="btn Button primaryBackground text-center text-white position-relative d-flex justify-content-center align-items-center"
                              onClick={() => fileInputImageRef.current.click()}
                            >
                              Upload Image
                            </button>
                            <input
                              type="file"
                              ref={fileInputImageRef}
                              className="d-none"
                              multiple
                              onChange={handleImageChange}
                            />
                          </>
                        )}

                        {/* Show preview only after upload */}
                        {imagePreview && (
                          <div className="d-flex align-items-center border rounded p-2 mt-2">
                            <img
                              src={imagePreview}
                              alt="Uploaded"
                              className="img-thumbnail me-3"
                              style={{
                                height: "120px",
                                width: "120px",
                                objectFit: "cover"
                              }}
                            />
                            <button
                              type="button"
                              className="btn btn-outline-danger btn-sm"
                              onClick={() => {
                                setImagePreview(null);
                                setSelectedImages([]);
                                if (fileInputImageRef.current) {
                                  fileInputImageRef.current.value = "";
                                }
                              }}
                            >
                              Remove
                            </button>
                          </div>
                        )}

                        {/* Error message */}
                        {errors.imagePreview && (
                          <div className="text-danger mt-2">
                            {errors.imagePreview}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {!isButtonDisabled ? (
                  <div className="d-flex justify-content-end mt-5 mb-4">
                    <button
                      type="reset"
                      onClick={handleCancel}
                      className="btn Button primaryColorText btn-outline-secondary me-2 no-hover-effect"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmit}
                      className="btn Button primaryBackground text-center text-white position-relative d-flex justify-content-center align-items-center"
                    >
                      {loading ? (
                        <Loader style={{ height: "30", width: "40" }} />
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
              {showCoupons == true && (
                <CouponModel
                  data={availableCoupons}
                  close={() => setShowCoupons(false)}
                  updateData={updateClickedCoupon}
                />
              )}
              {availableCoupons.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                >
                  <h5>Offers & Coupons</h5>
                  {availableCoupons.length > 0 && (
                    <div
                      onClick={() => setShowCoupons(true)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        cursor: "pointer"
                      }}
                    >
                      <span style={{ fontWeight: "600", color: "#000" }}>
                        View All Coupons
                      </span>
                      <span style={{ fontSize: "18px", color: "#000" }}>
                        &#10095;
                      </span>
                    </div>
                  )}
                  <div
                    style={{
                      backgroundColor: "#f9f9f9",
                      borderRadius: "8px",
                      marginTop: "12px",
                      padding: "10px 16px"
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div style={{ width: "15%", textAlign: "center" }}>
                        {/* Replace with a coupon icon if you have one */}
                        <span
                          role="img"
                          aria-label="coupon"
                          style={{ fontSize: 24 }}
                        >
                          🎟️
                        </span>
                      </div>
                      <div style={{ width: "65%" }}>
                        <input
                          type="text"
                          placeholder="Enter Coupon Code"
                          value={inputCoupon}
                          onChange={(e) =>
                            setInputCoupon(e.target.value.toUpperCase())
                          }
                          maxLength={20}
                          style={{
                            width: "100%",
                            padding: "8px",
                            fontSize: "14px",
                            border: "1px solid #ccc",
                            borderRadius: "6px"
                          }}
                        />
                      </div>
                      <div style={{ width: "20%", textAlign: "center" }}>
                        {couponLoader ? (
                          <div style={{ paddingTop: 10 }}>
                            <span>Loading...</span>{" "}
                            {/* Replace with spinner if needed */}
                          </div>
                        ) : (
                          <>
                            {showRemoveCoupon ? (
                              <button
                                type="button"
                                onClick={removeCoupon}
                                style={{
                                  background: "none",
                                  border: "none",
                                  color: "red",
                                  fontWeight: "bold",
                                  cursor: "pointer"
                                }}
                              >
                                Remove
                              </button>
                            ) : (
                              <button
                                type="button"
                                onClick={validateCoupon}
                                style={{
                                  background: "none",
                                  border: "none",
                                  color: "#000",
                                  fontWeight: "bold",
                                  cursor: "pointer"
                                }}
                              >
                                Apply
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <h3
                style={{
                  textAlign: "center",
                  fontSize: "1.75rem",
                  fontWeight: "500",
                  marginTop: "10px"
                }}
              >
                {system_payment.display_booking_id ? (
                  <span className="text-muted">
                    {system_payment.display_booking_id}
                  </span>
                ) : (
                  ""
                )}
              </h3>

              {showPaymentSummary && (
                <div
                  style={{
                    marginTop: "40px",
                    padding: "20px",
                    border: "1px solid #ccc",
                    borderRadius: "8px"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer"
                    }}
                    onClick={changeCollapse}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px"
                      }}
                    >
                      <h5 style={{ margin: 0 }}>Payment Summary</h5>
                    </div>
                    <div style={{ marginRight: "10px" }}>
                      {collapse?.paymentSummary ? "▲" : "▼"}
                    </div>
                  </div>

                  {collapse?.paymentSummary && (
                    <div style={{ paddingTop: "20px" }}>
                      {/* Offered Price */}
                      {system_offered_price !== null && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            paddingTop: 10
                          }}
                        >
                          <div style={{ width: "30%" }}>
                            <span>Offered Price</span>
                          </div>
                          <div style={{ width: "30%" }}>
                            <input
                              type="number"
                              value={system_offered_price ?? ""}
                              onChange={(e) => handleofferedprice(e)}
                              style={{ width: "100%", padding: "4px" }}
                            />
                          </div>
                        </div>
                      )}

                      {/* Coupon Discount */}
                      {coupon && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            paddingTop: 10
                          }}
                        >
                          <div style={{ width: "30%" }}>
                            <span>Coupon discount ({coupon.value}%)</span>
                          </div>
                          <div style={{ width: "30%" }}>
                            <strong>- AED {systemCoupondiscount}</strong>
                          </div>
                        </div>
                      )}

                      {/* Tax & Fees */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          paddingTop: 10
                        }}
                      >
                        <div style={{ width: "30%" }}>
                          <span>Tax & Fees</span>
                        </div>
                        <div style={{ width: "30%" }}>
                          <strong>AED {system_displayTax}</strong>
                        </div>
                      </div>

                      {paymentOption === 5 && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            paddingTop: 10
                          }}
                        >
                          <div style={{ width: "30%" }}>
                            <span>Cash Handling Fee</span>
                          </div>
                          <div style={{ width: "30%" }}>
                            <input
                              type="number"
                              value={cash_handling_fee}
                              onChange={(e) =>
                                handleUpdateCashFee(e.target.value)
                              }
                              style={{ width: "100%", padding: "4px" }}
                            />
                          </div>
                          {/* <div style={{ width: "35%" }}>
        <button
        type="button"
                                    className="btn btn"
          onClick={handleUpdateCashFee}
           style={{ background: "#d01c4c", color: 'white' }}
        >
         Update
        </button>
      
    </div> */}
                        </div>
                      )}

                      {/* Express Fee */}
                      {system_payment?.express_fee > 0 && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            paddingTop: 10
                          }}
                        >
                          <div style={{ width: "30%" }}>
                            <span>Express Charges</span>
                          </div>
                          <div style={{ width: "30%" }}>
                            <strong>AED {system_payment.express_fee}</strong>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Total */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      paddingTop: 20
                    }}
                  >
                    <div style={{ width: "30%" }}>
                      <strong>Total Amount</strong>
                    </div>
                    <div style={{ width: "30%" }}>
                      <strong>AED {system_rawtotal}</strong>
                    </div>
                  </div>
                </div>
                //                                 <div style={{ marginTop: "80px" }}>
                //                                     <h5>Payment Summary</h5>
                //                                     <div style={{ paddingBottom: "3%" }}>
                //                                         {/* Offered Price Row */}
                //                                         <div style={{ display: "flex", alignItems: "center", gap: "10px", paddingTop: 10 }}>
                //                                             <div style={{ width: "20%" }}>
                //                                                 <span>Offered Price</span>
                //                                             </div>
                //                                             <div style={{ width: "25%" }}>
                //                                                 <input
                //                                                     type="number"
                //                                                     value={system_offered_price}
                //                                                     onChange={(e) => setSystem_offered_price(e.target.value)}
                //                                                     style={{
                //                                                         width: "100%",
                //                                                         padding: "5px",
                //                                                         borderRadius: "4px",
                //                                                         border: "1px solid #ccc",
                //                                                     }}
                //                                                 />
                //                                             </div>
                //                                             <div>
                //                                                 <button onClick={(e) => handleSavePrice(e)} style={{ padding: "6px 12px" }}>
                //                                                     Save Price
                //                                                 </button>
                //                                             </div>
                //                                         </div>
                //  {coupon && (
                //                                             <>

                //                                                 <div style={{ display: "flex", alignItems: "center", gap: "10px", paddingTop: 10 }}>
                //                                                     <div style={{ width: "20%" }}>
                //                                                         <span>Coupon discount({coupon.value}%)</span>
                //                                                     </div>
                //                                                     <div style={{ width: "25%" }}>
                //                                                         <span><strong>AED {systemCoupondiscount}</strong></span>
                //                                                     </div>
                //                                                 </div>
                //                                             </>
                //                                         )}
                //                                         {/* Tax & Fees Row */}
                //                                         <div style={{ display: "flex", alignItems: "center", gap: "10px", paddingTop: 10 }}>
                //                                             <div style={{ width: "20%" }}>
                //                                                 <span>Tax & Fees</span>
                //                                             </div>
                //                                             <div style={{ width: "25%" }}>
                //                                                 <span><strong>AED {system_displayTax}</strong></span>
                //                                             </div>
                //                                         </div>
                //                                           <div style={{ display: "flex", alignItems: "center", gap: "10px", paddingTop: 10 }}>
                //                                             <div style={{ width: "20%" }}>
                //                                                 <span>Cash Handling Fee</span>
                //                                             </div>
                //                                             <div style={{ width: "25%" }}>
                //                                                 <span><strong>AED {cash_handling_fee}</strong></span>
                //                                             </div>
                //                                         </div>
                //                                         <div style={{ display: "flex", alignItems: "center", gap: "10px", paddingTop: 10 }}>
                //                                             <div style={{ width: "20%" }}>
                //                                                 <span>Express Charges</span>
                //                                             </div>
                //                                             <div style={{ width: "25%" }}>
                //                                                 <span><strong>AED {system_express_charge}</strong></span>
                //                                             </div>
                //                                         </div>
                //                                         {/* <div style={{ display: "flex", alignItems: "center", gap: "10px", paddingTop: 10 }}>
                //                                             <div style={{ width: "20%" }}>
                //                                                 <span>Platform Fees</span>
                //                                             </div>
                //                                             <div style={{ width: "25%" }}>
                //                                                 <span><strong>AED {systemPlatform}</strong></span>
                //                                             </div>
                //                                         </div>
                //  */}
                //                                         {/* Total Amount Row */}
                //                                         <div style={{ display: "flex", alignItems: "center", gap: "10px", paddingTop: 10 }}>
                //                                             <div style={{ width: "20%" }}>
                //                                                 <strong>Total Amount</strong>
                //                                             </div>
                //                                             <div style={{ width: "25%" }}>
                //                                                 <strong>AED {system_total}</strong>
                //                                             </div>
                //                                         </div>

                //                                     </div>
                //                                 </div>
              )}
              {/* {system_payment?.allowed_offer_service?.includes(system_payment?.serviceName) && (
                                <div
                                    style={{
                                        marginTop: "30px",
                                        border: "1px solid #ccc",
                                        padding: "20px",
                                        borderRadius: "8px",
                                        background: "#fff",
                                    }}
                                >
                                    <div
                                        style={{
                                            marginBottom: "20px",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >
                                        <h5 style={{ margin: 0 }}>Slide to set your price (Optional)</h5>
                                        <button
                                            type='button'
                                            onClick={resetBtn}
                                            style={{
                                                padding: "6px 12px",
                                                backgroundColor: "#d01c4c",
                                                color: "white",
                                                border: "none",
                                                borderRadius: "4px",
                                                cursor: "pointer",
                                            }}
                                        >
                                            Reset
                                        </button>
                                    </div>

                                    <input
                                        type="range"
                                        min={system_payment?.min_quoted_price}
                                        max={system_payment?.max_quoted_price}
                                        step={1}
                                        value={inputUserPrice}
                                        onChange={(e) => {
                                            setInputUserPrice(Number(e.target.value));
                                            sliderChanges(Number(e.target.value));
                                        }}
                                        style={{
                                            width: "100%",
                                            height: "8px",
                                            background: "#d01c4c",
                                            borderRadius: "5px",
                                            outline: "none",
                                            marginBottom: "10px",
                                        }}
                                    />

                                    {inputUserPriceError && (
                                        <div style={{ color: "red", paddingLeft: "10px", paddingTop: "5px" }}>
                                            {inputUserPriceError}
                                        </div>
                                    )}
                                    {lowPriceMessage && (
                                        <div style={{ color: "#333", paddingLeft: "10px", paddingTop: "5px" }}>
                                            {lowPriceMessage}
                                        </div>
                                    )}
                                </div>
                            )}
                            {userPrice !== 0 && !isNaN(user_taxes) && sliderTouched && (
                                <div style={{ marginTop: "40px", padding: "0 5%" }}>
                                    <div style={{ border: "1px solid #ccc", borderRadius: 8, padding: "2%" }}>
                                        <div
                                            onClick={() => changeCollapse("finalpaymentSummary")}
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                cursor: "pointer",
                                            }}
                                        >
                                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                                <strong style={{ fontSize: "16px" }}>Final Payment Summary</strong>
                                            </div>
                                            <div style={{ marginRight: "2%" }}>
                                                {collapse?.finalpaymentSummary ? (
                                                    <span>&#9650;</span> 
                                                ) : (
                                                    <span>&#9660;</span>
                                                )}
                                            </div>
                                        </div>

                                        <hr />

                                        <div style={{ paddingBottom: "3%" }}>
                                            {collapse?.finalpaymentSummary && (
                                                <>
                                                    <div style={{ display: "flex", paddingTop: 10 }}>
                                                        <div style={{ width: "65%" }}>
                                                            <span>Quoted Amount</span>
                                                        </div>
                                                        <div style={{ width: "35%" }}>
                                                            <strong>AED {userPrice}</strong>
                                                        </div>
                                                    </div>

                                                    {coupon && (
                                                        <div style={{ display: "flex", paddingTop: 10 }}>
                                                            <div style={{ width: "65%" }}>
                                                                <span>Coupon discount ({coupon.value}%)</span>
                                                            </div>
                                                            <div style={{ width: "35%" }}>
                                                                <strong>-AED {user_coupon_discount}</strong>
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div style={{ display: "flex", paddingTop: 10 }}>
                                                        <div style={{ width: "65%" }}>
                                                            <span>Tax & Fees</span>
                                                        </div>
                                                        <div style={{ width: "35%" }}>
                                                            <strong>AED {user_taxes}</strong>
                                                        </div>
                                                    </div>

                                                    {paymentOption === 5 && (
  <div style={{ display: "flex", paddingTop: 10 }}>
    <div style={{ width: "65%" }}>
      <span>Cash Handling Fee</span>
    </div>
    <div style={{ width: "35%" }}>
      <input
        type="number"
        value={cash_handling_fee}
        onChange={(e) => setCash_handling_fee(e.target.value)}
        style={{ width: "100%", padding: "4px" }}
      />
    </div>
  </div>
)}


                                                    {system_payment?.express_fee > 0 && (
                                                        <div style={{ display: "flex", paddingTop: 10 }}>
                                                            <div style={{ width: "65%" }}>
                                                                <span>Express Fee</span>
                                                            </div>
                                                            <div style={{ width: "35%" }}>
                                                                <strong>AED {system_payment?.express_fee}</strong>
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            )}

                                            <div style={{ display: "flex", paddingTop: 10 }}>
                                                <div style={{ width: "65%" }}>
                                                    <span style={{ fontWeight: "500", color: "#000" }}>
                                                        Total Amount
                                                    </span>
                                                </div>
                                                <div style={{ width: "35%" }}>
                                                    <strong style={{ fontWeight: "500", color: "#000" }}>
                                                        AED {user_total}
                                                    </strong>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )} */}
              <div
                style={{
                  padding: 20,
                  display: "flex",
                  justifyContent: "center"
                }}
              >
                <button
                  onClick={pay}
                  disabled={
                    loader ||
                    !system_offered_price ||
                    isNaN(system_offered_price) ||
                    parseFloat(system_offered_price) === 0
                  }
                  className="btn Button primaryBackground text-white position-relative d-flex justify-content-center align-items-center"
                  style={{
                    minWidth: "200px",
                    padding: "12px 24px",
                    fontSize: "16px",
                    borderRadius: "8px",
                    border: "none"
                  }}
                >
                  {loader ? (
                    <span
                      style={{
                        display: "inline-block",
                        height: "20px",
                        width: "20px",
                        border: "3px solid #fff",
                        borderTop: "3px solid transparent",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite"
                      }}
                    ></span>
                  ) : (
                    `Pay`
                  )}
                </button>

                <style>{`
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `}</style>
              </div>
            </div>
          </div>
        </div>
        <hr />

        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          size="xl"
          backdrop="static"
        >
          <div className="p-4">
            <h5 className="text-center mb-4">Add New Address</h5>

            {/* <GooglePlacesAutocomplete
                         apiKey='AIzaSyAatqW_QBs26_bOCVlVBBxFRy3L7dPkiEU'
                            // onPress={async (data, details = null) => {
                            //     alert()
                            //     const response = await fetch(
                            //         `https://maps.googleapis.com/maps/api/place/details/json?placeid=${data.place_id}&key=${constants.google_places_key}&language=en`
                            //     );
                            //     const result = await response.json();
                            //     if (result.status === "OK") {
                            //         updateAddress(result.result);
                            //     } else {
                            //         console.warn("Place details fetch failed", result);
                            //     }
                            // }} 
                            /> */}
            {/* <PlacesAutocomplete
                            value={addressText}
                            onChange={(address) => setAddressText(address)}  // just updates input
                            onSelect={handleSelect}                          // handles full selection
                        >
                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                <div>
                                    <input
                                        {...getInputProps({
                                            placeholder: "Enter an address",
                                            className: "autocomplete-input",
                                        })}
                                    />
                                    <div className="autocomplete-dropdown">
                                        {loading && <div>Loading...</div>}
                                        {suggestions.map((suggestion) => (
                                            <div
                                                key={suggestion.placeId || suggestion.description}
                                                {...getSuggestionItemProps(suggestion)}
                                                className="suggestion-item"
                                            >
                                                {suggestion.description}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </PlacesAutocomplete> */}

            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">Address</label>
                <input
                  type="text"
                  className="form-control"
                  // value={addressText}
                  onChange={(e) => setAddressText(e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Home No</label>
                <input
                  type="text"
                  className="form-control"
                  // value={houseNo}
                  onChange={(e) => setHouseNo(e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Area</label>
                <input
                  type="text"
                  className="form-control"
                  // value={houseName}
                  onChange={(e) => setHouseName(e.target.value)}
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">Landmark</label>
                <input
                  type="text"
                  className="form-control"
                  // value={landMark}
                  onChange={(e) => setLandMark(e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Label</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="e.g. Home, Office"
                  // value={label}
                  onChange={(e) => setSaveAs(e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">State</label>
                <select
                  className="form-control"
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                >
                  <option value="">Select State</option>
                  {stateList?.map((name) => (
                    <option key={name.id} value={name.name}>
                      {name.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="d-flex justify-content-center">
              <button
                className="mx-2 btn btn-outline-secondary"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                style={{
                  background: "#d01c4c",
                  minWidth: "100px",
                  color: "white"
                }}
                onClick={SaveAddress}
              >
                Save Address
              </button>
            </div>
          </div>
        </Modal>
      </form>
    </div>
  );
};

export default OrderForm;
